import ReportWinnersList from './report-winners.list';

export default {
  list: ReportWinnersList,
};
